import { c as _c } from "react/compiler-runtime";
interface SecaoVaziaCertificadoProps {
  mensagem: string;
}
export function SecaoVaziaCertificado(t0) {
  const $ = _c(2);
  const {
    mensagem
  } = t0;
  let t1;
  if ($[0] !== mensagem) {
    t1 = <div className="px-[37px] pb-6"><div className="flex items-center justify-center rounded-[8px] border border-solid border-neutral-200 bg-neutral-50 px-4 py-4 text-center"><span className="text-[12.5px] text-neutral-500">{mensagem}</span></div></div>;
    $[0] = mensagem;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}